import Vue from "vue";

import VueI18n from "vue-i18n";
Vue.use(VueI18n);
import messages from "./i18n/index.js";

// Pick a locale that we actually have translations for, based on the
// browser's preferred languages (navigator.languages, ordered by priority).
// Match on the base language code (e.g. "en-US" -> "en"), falling back to
// "en" when none of the browser languages are available in the i18n folder.
export function getBrowserLocale() {
  const arrLangs =
    navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language || navigator.userLanguage || "en"];

  for (const strLang of arrLangs) {
    const strBase = String(strLang).toLowerCase().split("-")[0];
    if (Object.prototype.hasOwnProperty.call(messages, strBase)) {
      return strBase;
    }
  }
  return "en";
}

const i18n = new VueI18n({
  locale: getBrowserLocale(),
  fallbackLocale: "en",
  messages,
});
export { i18n };
